import { ReactZoomPanPinchState } from '@pronestor/react-zoom-pan-pinch';
import { useState } from 'react';

// react-zoom-pan-pinchのズーム倍率・座標情報を管理するhooks
export const useZoomState = (
  initScale = 1,
  initPreviousScale = 1,
  initPositionX = 0,
  initPositionY = 0
) => {
  const [zoomState, setZoommState] = useState<ReactZoomPanPinchState>({
    scale: initScale,
    previousScale: initPreviousScale,
    positionX: initPositionX,
    positionY: initPositionY
  });

  return { zoomState, setZoommState };
};
